import aristo from "../projects/aristo.txt";
import plato from "../projects/plato.txt";
import rl from "../projects/plato_rl.txt";
import sony from "../projects/sony.txt";
import hcrl from "../projects/hcrl-ugrad-research.txt";
import samsung from "../projects/samsung.txt";
import hero from "../projects/hero.txt";
import fire from "../projects/fire.txt";
import hockey from "../projects/hockey.txt";
import battle from "../projects/battle.txt";
import car from "../projects/car.txt";
import lowCostAnthroHand from "../projects/low-cost-single-actuator-anthropomorphic-hand.txt";
import handDesigns from "../projects/hand-designs.txt";

const MARKUPS = {
  aristo,
  plato,
  rl,
  sony,
  hcrl,
  samsung,
  hero,
  fire,
  hockey,
  battle,
  car,
  lowCostAnthroHand,
  handDesigns,
};

export default MARKUPS;
